import {
  GET_COMS_CHANNEL_CONFIG_PROJECT,
  GET_COMS_CHANNEL_CONFIG_PROJECT_SUCCESS,
  GET_COMS_CHANNEL_CONFIG_PROJECT_ERROR,
  GET_COMS_CHANNEL_CONFIG_PROJECT_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetComsChannelConfig = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMS_CHANNEL_CONFIG_PROJECT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_COMS_CHANNEL_CONFIG_PROJECT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_COMS_CHANNEL_CONFIG_PROJECT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_COMS_CHANNEL_CONFIG_PROJECT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetComsChannelConfig;
